import { datadogRum } from '@datadog/browser-rum'

import { DD_RUM_ENABLED_FLAG } from '@src/config/env'
import appData from '@src/quince-site-common/src/helpers/appData'

import { FeatureType, MODULES, ModuleType } from '../../constants/template-info'
import QuinceApiError from '../../domains/quince-api-error'

export function captureError(error: unknown, info?: object) {
  if (!error && !info) {
    return
  }

  if (DD_RUM_ENABLED_FLAG) {
    datadogRum.addError(error, info)
  }
}

export function captureFatalException(error: any, errorInfo?: Record<string, any>) {
  captureError(error, {
    ...(errorInfo ?? {}),
    // eslint-disable-next-line i18next/no-literal-string
    level: 'fatal',
  })
}

export function captureException(
  error: any,
  options: {
    module: ModuleType
    feature: FeatureType
    additionalTags?: Record<string, string | number | null | boolean>
    extraInfo?: Record<string, unknown>
  },
) {
  const { module = MODULES.UNKNOWN, feature = MODULES.UNKNOWN, extraInfo, additionalTags } = options
  const templateType = appData.getTemplateType()
  const _errorInfo = { ...extraInfo }
  const _tags: Record<string, string | number | null | boolean> = {
    ...additionalTags,
    templateType: templateType as string,
    module: module as string,
    feature: feature as string,
  }

  if (error instanceof QuinceApiError) {
    _errorInfo.data = error.data
    _errorInfo.apiErrorObject = error.apiErrorObject
    _tags.type = 'QUINCE_API_ERROR'
    _tags.api = error.name
    _tags.apiErrorCode = ('code' in error.apiErrorObject && error.apiErrorObject.code) ?? 'UNKNOWN'
  }

  captureError(error, { ..._errorInfo, tags: _tags })
}

export function captureWarning(warning: string, info: Record<string, any>, tags: Record<string, any>) {
  captureError(warning, { ...info, tags })
}

export function captureEvent(event: unknown, info?: Record<string, any>) {
  captureError(event, info)
}
